export default {
  en: {
    title: 'History',
    empty: 'No conversations yet — start your first one on the home screen.',
    swipeHint: 'Swipe left to delete a conversation',
    retentionNotice: 'Inactive conversations are deleted after 2 weeks',
    deleteAria: 'Delete conversation "{{title}}"',
    lessonTitle: 'Lesson',
    freeConversationTitle: 'Free conversation',
    youPrefix: 'You: ',
    conversationStarted: 'Conversation started',
    yesterday: 'Yesterday',
    loadingSr: 'Loading history',
  },
  ru: {
    title: 'История',
    empty: 'Пока ни одного разговора — начните первый на главном экране.',
    swipeHint: 'Свайпните влево, чтобы удалить диалог',
    retentionNotice: 'Неактивные разговоры удаляются через 2 недели',
    deleteAria: 'Удалить разговор «{{title}}»',
    lessonTitle: 'Урок',
    freeConversationTitle: 'Свободный разговор',
    youPrefix: 'Вы: ',
    conversationStarted: 'Разговор начат',
    yesterday: 'Вчера',
    loadingSr: 'Загружаем историю',
  },
  de: {
    title: 'Verlauf',
    empty: 'Noch keine Gespräche — starte dein erstes auf dem Startbildschirm.',
    swipeHint: 'Wische nach links, um einen Dialog zu löschen',
    retentionNotice: 'Inaktive Gespräche werden nach 2 Wochen gelöscht',
    deleteAria: 'Gespräch „{{title}}“ löschen',
    lessonTitle: 'Lektion',
    freeConversationTitle: 'Freies Gespräch',
    youPrefix: 'Du: ',
    conversationStarted: 'Gespräch gestartet',
    yesterday: 'Gestern',
    loadingSr: 'Verlauf wird geladen',
  },
  pt: {
    title: 'Histórico',
    empty: 'Nenhuma conversa ainda — comece a primeira na tela inicial.',
    swipeHint: 'Deslize para a esquerda para excluir um diálogo',
    retentionNotice: 'Conversas inativas são excluídas após 2 semanas',
    deleteAria: 'Excluir conversa “{{title}}”',
    lessonTitle: 'Lição',
    freeConversationTitle: 'Conversa livre',
    youPrefix: 'Você: ',
    conversationStarted: 'Conversa iniciada',
    yesterday: 'Ontem',
    loadingSr: 'Carregando histórico',
  },
  fr: {
    title: 'Historique',
    empty: 'Aucune conversation pour l’instant — lance la première sur l’écran d’accueil.',
    swipeHint: 'Balaye vers la gauche pour supprimer un dialogue',
    retentionNotice: 'Les conversations inactives sont supprimées après 2 semaines',
    deleteAria: 'Supprimer la conversation « {{title}} »',
    lessonTitle: 'Leçon',
    freeConversationTitle: 'Conversation libre',
    youPrefix: 'Toi : ',
    conversationStarted: 'Conversation lancée',
    yesterday: 'Hier',
    loadingSr: 'Chargement de l’historique',
  },
  es: {
    title: 'Historial',
    empty: 'Aún no hay conversaciones — empieza la primera en la pantalla de inicio.',
    swipeHint: 'Desliza a la izquierda para eliminar un diálogo',
    retentionNotice: 'Las conversaciones inactivas se eliminan después de 2 semanas',
    deleteAria: 'Eliminar conversación “{{title}}”',
    lessonTitle: 'Lección',
    freeConversationTitle: 'Conversación libre',
    youPrefix: 'Tú: ',
    conversationStarted: 'Conversación iniciada',
    yesterday: 'Ayer',
    loadingSr: 'Cargando historial',
  },
};
